import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setLoading, setProductsRate } from "../../repository/slice";

function* getProductsRateWorker({ payload }: any): SagaIterator {
    try {
        yield put(setLoading(true));
        const { data, message, isError }: IResponse<any> = yield call(requester.get, "/api/shop/order/statistics", payload);
        if (isError) {

        } else {
            yield put(setProductsRate(data.statistics));
        }
    } catch (error) {
        console.error("getProductsRateWorker: ", error);
    } finally {
        yield put(setLoading(false));
    };
};

export function* getProductsRateWatcher() {
    yield takeLatest("@saga/GET_PRODUCTS_RATE", getProductsRateWorker);
};